'use client';

import { useGlossaryDictionary } from '@/app/[locale]/(learning)/glossary/_component/DictionaryProvider';
import SearchIcon from '@/assets/icons/Search';
import LineWithDot from '@/components/lineWithDot';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

export default function SearchForm({ placeholder, submitLabel }) {
  const { inputRef, errorMessage, handleSearch } = useGlossaryDictionary();

  return (
    <div className='flex justify-center sm:justify-stretch'>
      <div aria-hidden='true' className='sm:ml-auto relative'>
        <LineWithDot variant='secondary' className='hidden sm:block' />
      </div>
      <div className='flex flex-col relative sm:max-w-xl w-full border border-zinc-200 rounded ps-3'>
        <div className='grid grid-cols-[auto_1fr_auto] items-center'>
          <SearchIcon className='size-4' />
          <Input
            className='border-none h-full focus-visible:ring-0 placeholder:italic'
            placeholder={placeholder}
            ref={inputRef}
            onKeyDown={event => {
              if (event.key === 'Enter') {
                handleSearch();
              }
            }}
          />
          <Button variant='secondary' className='rounded-none rounded-e px-4 h-10' onClick={handleSearch}>
            {submitLabel}
          </Button>
        </div>

        {errorMessage && <p className='text-xs absolute -bottom-6 text-red-500 italic'>{errorMessage}</p>}
      </div>
    </div>
  );
}
